export const QRTypes = {
    SET_LOCATIONTYPEDATA: "SET_LOCATIONTYPEDATA",
    GET_QRCODEDATA: "GET_QRCODEDATA",
    UPDATE_QRCODEDATA:"UPDATE_QRCODEDATA",
    GET_QRCODETHUMBNAIL: "GET_QRCODETHUMBNAIL",
    SAVE_MEDIATYPES: "SAVE_MEDIATYPES",
    PUT_LOCATIONIDBYQRCODE: "UPDATE_LOCATIONIDBYQRCODE",
    GET_VIRTUALQRCODE: "GET_VIRTUALQRCODE",
    
}